import { Stack } from '@mantine/core';

import { Id } from '@feature/utils';

import { GovAuthorEvaluation } from '../model/GovEvaluationTypes';
import { GovEvaluationAnnexItem } from './GovEvaluationAnnexItem';

interface GovEvaluationAuthorAnnexProps {
  data: GovAuthorEvaluation;
  hideOptionals: boolean;
  canEdit: boolean;

  authorId: Id;
  evaluationId: Id;
}

export function GovEvaluationAuthorAnnex({
  data,
  hideOptionals,
  canEdit,
  evaluationId,
  authorId,
}: GovEvaluationAuthorAnnexProps) {
  const { evaluation, authorAnnexes } = data;
  const { annexList } = evaluation;
  return (
    <Stack>
      {annexList
        .filter(it => (hideOptionals ? it.required : true))
        .map(annex => (
          <GovEvaluationAnnexItem
            annex={annex}
            key={annex.id}
            canEdit={canEdit}
            evaluationId={evaluationId}
            authorId={authorId}
            authorAnnex={authorAnnexes.filter(aa => aa.annex.id === annex.id)[0]}
          />
        ))}
    </Stack>
  );
}
